import React, { useState, useEffect } from "react";
import "./MiniSaver.css";

const STAGES = [
  {
    label: "Click to go to modules",
    bg: "linear-gradient(135deg, rgba(39, 185, 93, 1), #1bb532ff)"
  },
  {
    label: "A quick guide to a credit that can reach $2,000",
    bg: "linear-gradient(135deg, #7087ebff, #1a29f4ff)"
  },
];

export default function Mini() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    // auto-rotate every 4 seconds
    const timer = setTimeout(() => {
      setIndex((prev) => (prev + 1) % STAGES.length);
    }, 3000);

    return () => clearTimeout(timer);
  }, [index]);

  const stage = STAGES[index]; // always 0 or 1.  onClick={() => window.location.href = "/saver"}

  return (
  <div className="mini-wrapper">
  <div
    className="mini-card"
    style={{ background: stage.bg }}
    onClick={() => (window.location.href = "/saver")}
  >
    <div className="mini-title">{stage.label}</div>
  </div>
</div>

  );
}
